export default __webpack_public_path__ + "static/media/rolling.360ac231.gif";